import { render, staticRenderFns } from "./SideCard.vue.js?vue&type=template&id=044893b6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SideCard.vue?vue&type=template&id=044893b6"
import script from "./SideCard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SideCard.vue?vue&type=script&lang=js"
export * from "./SideCard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SideCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports